const FetchInterceptor = require('fetch-interceptor');
let status = false
export const interceptor = FetchInterceptor.register({

    onRequestFailure(response) {
        console.log("response", response)
        if (response.status === 401 && status === false) {
            status = true
            let url = "https://vauthprovider-529d8.web.app/"
            if (BUILDTYPE == 'PROD') {
                url = 'https://vauth.mobiotics.com'
            }
            caches.delete('vsms1').then(rep => {
                console.log(rep)
            })
            let redirectUrl = `${url}?serviceurl=${window.location.origin}&servicename=vsms`;
            window.location.replace(redirectUrl)
        }
    }
});


// WEBPACK FOOTER //
// ./src/interceptorHub/index.js